import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { whatsappLink } from "../../config";
import { track } from "../../lib/api";

const links = [
  { href: "#servicios", label: "Servicios" },
  { href: "#casos", label: "Casos" },
  { href: "#proceso", label: "Proceso" },
  { href: "#precios", label: "Precios" },
  { href: "#faq", label: "FAQ" },
];

export const Nav = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img src="/logo-wordmark.png" alt="Juan Pablo Cortés" className="h-6 sm:h-7 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="text-sm text-zinc-400 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp"
            onClick={() => track("whatsapp_click", null, { location: "nav" })}
            className="text-sm text-zinc-400 hover:text-white transition-colors duration-200"
          >
            WhatsApp
          </a>
          <button
            data-testid="nav-book-btn"
            onClick={onBook}
            className="rounded-full bg-[var(--magenta)] text-white text-sm font-semibold px-5 py-2.5 hover-lift hover:magenta-glow"
          >
            Agendar llamada
          </button>
        </div>

        <button
          className="md:hidden text-white"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menú"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-white/10 px-5 py-5 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-zinc-300 text-base"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="nav-book-btn-mobile"
            onClick={() => {
              setOpen(false);
              onBook();
            }}
            className="rounded-full bg-[var(--magenta)] text-white font-semibold px-5 py-3 mt-1"
          >
            Agendar llamada
          </button>
        </div>
      )}
    </header>
  );
};
